import styled, { keyframes } from 'styled-components';

const TypingAnimation = keyframes`  
   0%, 100% {
    transform: translateY(0);
    opacity: 1;
  }
  50% {
    transform: translateY(-5px); 
    opacity: 0.5;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;

  height: 20px;
  align-items: center;
  padding: 0 15px;

  span {
    width: 8px;
    height: 8px;
    background-color: ${({ theme }) => theme.colors.TEXT3};
    border-radius: 50%;
    margin: 0 3px;
    animation-name: ${TypingAnimation};
    animation-duration: 1s;
    animation-iteration-count: infinite;
    animation-direction: ease-in-out;
  }

  span:nth-child(0) {
    animation-delay: 0s;
  }

  span:nth-child(1) {
    animation-delay: 0.2s;
  }

  span:nth-child(2) {
    animation-delay: 0.4s;
  }
`;
